var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"mb-4"},[_c('h3',{staticClass:"text-black text-2xl mb-0 font-semibold"},[_vm._t("default")],2),_c('p',{staticClass:"text-sm font-light text-gray-500"},[_vm._t("text")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }